import { Link } from 'react-router-dom';
import { CheckboxField } from '../ui/Field';
import { PATHS } from '../../routes/paths';

/**
 * The legally significant consent wording. Every surface that captures
 * vendor/user consent (claim page, action-gate modal) must render this one
 * component so users always agree to identical text.
 */
export default function TermsConsentField({ checked, onChange, error }) {
  return (
    <CheckboxField
      label={<>
        I agree to VGO's{' '}
        <Link to={PATHS.terms} target="_blank" className="font-semibold text-brand hover:underline">terms of service</Link>{' '}
        and{' '}
        <Link to={PATHS.privacy} target="_blank" className="font-semibold text-brand hover:underline">privacy policy</Link>.
      </>}
      checked={checked}
      onChange={onChange}
      error={error} />
  );
}
